<template>
<div class="card-top-level">
  <div v-if="imageUrl">
    <img :src="imageUrl" class="card-image" alt="Image of the menu item" aria-label="Image of the menu item"/>
  </div>
  <div class="card-info">
    <div class="menu-card">
      <div class="title">
        <strong v-if="marked" class="star">&#42;</strong>
        <h5>{{ name }}</h5>
      </div>
      <div class="item-header"></div>
      <p v-if="type ==='wine'" class="rooster-red bold">{{ location }}</p>
      <p>{{ desc }}</p>
    </div>
    <div class="price text-right">
      <p v-if="price"><span v-if="type === 'wine'" class="bold">Glass </span><span v-if="!isNaN(price)">$</span>{{ price }}</p>
      <p v-if="bottlePrice"><span class="bold">Bottle </span>${{ bottlePrice }}</p>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'MenuItem',
  props: ['index', 'name', 'desc', 'price', 'imageUrl', 'marked', 'bottlePrice', 'type', 'location']
}
</script>

<style scoped>
.card-top-level {
  margin-top: 10px;
  margin-right: 20px;
  margin-left: 20px;
  background-color: white;
  max-width: 400px;
  padding: 0;
  min-height: 150px;
  box-shadow: 0px 0px 3px #888888;
}

.card-info {
  display: flex;
}

.menu-card {
  padding: 10px;
}

.card-image {
  max-width: 100%;
}

.price {
  margin: 10px 10px auto auto;
}

.bottle-price {
  margin: 10px 10px auto auto;
}

.title {
  display: flex;
}

.star {
  color: #8a0707;
  font-size: 1.6em;
  margin-right: 5px;
}

.item-header {
  margin: 0;
  padding: 0;
  margin-bottom: 10px;
  width: 50px;
  border-bottom: 1px solid #8a0707;
}
</style>



// WEBPACK FOOTER //
// src/components/MenuItem.vue